import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ModuleService } from '@intellio/shared/services';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as ModuleConfigsActions from './module-configs.actions';

@Injectable()
export class ModuleConfigsEffects {
  getModuleConfigs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ModuleConfigsActions.getModuleConfigs),
      mergeMap(({ moduleId }) =>
        this.moduleService.getModuleConfigs(moduleId).pipe(
          map((configs) => {
            return ModuleConfigsActions.getModuleConfigsSuccess({
              moduleId,
              configs: configs.data,
            });
          }),
          catchError((error) => {
            return of(
              ModuleConfigsActions.getModuleConfigsFailure({
                moduleId,
                error,
              })
            );
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private moduleService: ModuleService
  ) {}
}
